/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import {
  Container,
  Logo,
  Title,
  List,
  Item,
  Settings,
  SubTitle,
  Content,
  Version,
  SubTitleVersion,
  TextVersion
} from "./styles";
import Icon from "../Icon/";
import { FitinsurAPI } from "../../utils";
import { GlobalAuthContext } from "../../store/context";
import { useHistory } from "react-router-dom";
import logo from "../../assets/logos/hdi_global_logo.png";
import HasPermission from 'components/HasPermission/index';
import Access from 'constants/Access';

export default function Menu(props) {
  const setShowProfile = props.showProfile;

  const [showDashboard, setShowDashboard] = useState(false);
  const [showEnquires, setShowEnquires] = useState(false);
  const [showManagement, setShowManagement] = useState(false);

  const packageJsonInfo = require('../../../package.json');
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();

  const goToHomePage = () => {
    history.push("home");
  };

  function requestAccess(
    username,
    dsDomPrivilege,
    idDomain,
    idPersonRelation,
    idOperation,
    menu
  ) {
    fitinsur.setAuthToken(authContext.token);
    fitinsur
      .requestAccess(
        username,
        dsDomPrivilege,
        idDomain,
        idPersonRelation,
        idOperation
      )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.ret_code === 200) {
          menu(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  useEffect(() => {
    requestAccess("", "READ", Access.MENU_ACCESS.DASHBOARD, null, null, setShowDashboard);
    requestAccess("", "READ", Access.MENU_ACCESS.ENQUIRIES, null, null, setShowEnquires);
    requestAccess("", "READ", Access.MENU_ACCESS.MANAGEMENT, null, null, setShowManagement);
  }, []);

  return (
    <Content>
      <Container>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "98%",
          }}
        >
          <div>
            <Logo src={logo} onClick={() => goToHomePage()}></Logo>
            <Title>Menu</Title>
            <List>
              <HasPermission permission={showDashboard}>
                <NavLink to="/home" activeClassName="active" exact={true}>
                  <Item>
                    <Icon name="dashboard" />
                    Painel
                  </Item>
                </NavLink>
              </HasPermission>

              <HasPermission permission={showEnquires}>
                <NavLink
                  to="/enquiries"
                  activeClassName="active"
                  exact={true}
                  onClick={() => {
                    localStorage.removeItem("enquiries_filter");
                  }}
                >
                  <Item>
                    <Icon name="enquiries" />
                    Cotações
                  </Item>
                </NavLink>
              </HasPermission>

              <HasPermission permission={showManagement}>
                <NavLink
                  to="/management/58/person"
                  activeClassName="active"
                  exact={true}
                  onClick={() => {
                    localStorage.removeItem("management_filter")
                  }}
                >
                  <Item>
                    <Icon name="management" />
                    Administração
                  </Item>
                </NavLink>
              </HasPermission>

            </List>
          </div>
          <div
            style={{
              marginBottom: "30px",
            }}
          >
            <Settings>
              <List>
                <SubTitle>Configurações</SubTitle>
                <Item
                  onClick={() => {
                    setShowProfile(true);
                  }}
                >
                  <Icon name="user" />
                  Minha Conta
                </Item>
                <Item
                  onClick={() => {
                    console.log('admin')
                  }}
                >
                  <Icon name="config-gray" />
                  Administração
                </Item>
                <Item
                  onClick={() => {
                    console.log('support')
                  }}
                >
                  <Icon name="mail-gray" />
                  Suporte
                </Item>
                <NavLink to="/login">
                  <Item>
                    <Icon name="logout" />
                    Sair
                  </Item>
                </NavLink>
              </List>
            </Settings>
            <Version>
              <SubTitleVersion>Version</SubTitleVersion>
              <TextVersion>{packageJsonInfo.version}</TextVersion>
            </Version>
          </div>
        </div>
      </Container>
    </Content>
  );
}
